<template>
  <FourElement />
  <div class="collection-container">
    <Filter />
    <List v-if="dataSource && dataSource.length > 0" />
    <div v-if="dataSource && dataSource.length > 0">
      <div class="fs14 lh30 fl" style="color: #999999;">
        {{
          `共 ${pagination.total} 条记录，第${pagination.pageNum} / ${~~(
            pagination.total / pagination.pageSize
          ) +
            (pagination.total % pagination.pageSize
              ? 1
              : pagination.total === 0
              ? 1
              : 0)}页`
        }}
      </div>
      <div
        style="display: flex; flex-direction: row; float: right; padding-bottom: 50px;"
      >
        <a-pagination
          v-if="pagination.pageSize"
          class="mr20"
          v-model:current="pagination.pageNum"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :showTotal="() => false"
          showSizeChanger
          showQuickJumper
          @change="initList"
        />
      </div>
    </div>
  </div>
  <Log />
  <Modal />
</template>
<script>
import { toRefs, reactive, provide, onMounted } from 'vue'
import FourElement from './components/FourElement'
import Filter from './components/Filter'
import List from './components/List'
import Log from './components/Log'
import Modal from './components/Modal'
import useAPI from 'UseApi'
import { message } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'
const { common_querySiteInfo_get_ } = useAPI(null, [3426])
import {
  redirect_list_post,
  redirect_delete_get,
  redirect_export_post
  // redirect_import_post
} from '@/server/modules/798'

export default {
  components: {
    FourElement,
    Filter,
    List,
    Log,
    Modal
  },
  setup() {
    const state = reactive({
      columns: [
        {
          title: '重定向自',
          dataIndex: 'redirectFrom',
          align: 'center'
        },
        {
          title: '重定向至',
          dataIndex: 'redirectTo',
          align: 'center'
        },
        {
          title: '场景',
          dataIndex: 'scene',
          align: 'center'
        },
        {
          title: '状态码',
          dataIndex: 'statusCode',
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createUser',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '操作',
          slots: { customRender: 'deal' },
          key: 'deal',
          align: 'center',
          width: 200
        }
      ],
      downloadFile: async () => {
        const { success, retInfo } = await redirect_export_post({
          ...state.postParams,
          ...state.searchParams
        })
        if (success) {
          message.success('导出成功')
        } else {
          message.error(retInfo)
        }
      },
      importFile: async ({ info }) => {
        const { success, retInfo } = await formRequest(
          `${process.env.VUE_APP_COMMON}/redirect/import`,
          {
            file: [info.file],
            ...state.searchParams
          }
        )
        if (success) {
          message.success(retInfo)
        } else {
          message.error(retInfo)
        }
        state.temList = []
        state.importVisible = false
        state.initList(1)
      },
      importVisible: false,
      visible: false,
      clicked: false,
      hovered: false,
      handleHoverChange: visible => {
        state.clicked = false
        state.hovered = visible
      },
      handleClickChange: visible => {
        state.clicked = visible
        state.hovered = false
      },
      hide: () => {
        state.clicked = false
        state.hovered = false
      },
      watchPage: e => {
        state.pagination.pageNum = e
        state.initList(e)
      },
      deleteFun: async params => {
        await redirect_delete_get(params)
        state.initList(1)
      },
      value: null,
      dataSource: [],
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      brands: [],
      channels: [],
      sites: [],
      postParams: {
        scene: '',
        redirectTo: '',
        redirectFrom: '',
        statusCode: '' // 状态
      },
      resetParams: () => {
        state.postParams = {
          scene: '',
          redirectTo: '',
          redirectFrom: '',
          statusCode: '' // 状态
        }
        state.initList()
      },
      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      resetPagination: () => {
        state.pagination = {
          pageNum: 1, // 当前页
          pageSize: 10, // 每页的数量
          total: 0 // 总记录数
        }
        state.initList()
      },
      logList: [],
      logPagination: {
        pageNum: 1, // 当前页
        pageSize: 5, // 每页的数量
        total: 0 // 总记录数
      },
      initList: async (pageNum, pageSize) => {
        if (pageNum) {
          state.pagination.pageNum = pageNum
        }
        if (pageSize) {
          state.pagination.pageSize = pageSize
        }
        const { data } = await redirect_list_post({
          ...state.pagination,
          ...state.postParams,
          ...state.searchParams
        })
        state.dataSource = data.list
        state.pagination.total = data.total
      }
    })

    onMounted(() => {
      common_querySiteInfo_get_({
        state
      })
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
